<template>
  <div class="w-full">
    <div class="w-full flex justify-between">
      <label class="text-sm flex items-center w-80 lg:w-full pl-1 lg:pl-6">
        <img src="/sepa.png" alt="sepa" class="w-10">
        <span v-if="iban" class="w-full lg:w-1/2 pl-3 md:pl-0 flex
        justify-start md:justify-center font-xs">
          xxxxxxxxxxxxxxxxxx{{iban.iban_last_four}}
        </span>
      </label>
      <button class="hover:text-b2c-red-300 w-3 px-4 md:px-6" v-if="!notShowBin"
        @click="openAreYouSure()" title="delete">
        <bin-icon />
      </button>
    </div>

  </div>
</template>

<script>
import AreYouSureToDeleteCard from '@/components/modals/AreYouSureToDeleteCard.vue';
import BinIcon from '@/components/graphics/BinIcon.vue';

export default {
  props: ['iban', 'notShowBin'],

  data() {
    return {
      expired: false,
    };
  },

  components: {
    BinIcon,
  },

  methods: {
    openAreYouSure() {
      this.$modal.show(AreYouSureToDeleteCard, { id: this.iban.id }, { height: 'auto', adaptive: true });
    },

  },

};
</script>
